import axios from 'axios';
import { apiServerHost } from '../../common/APIServerSettings';

const createEntity = (callBackFunc, entityUpdateID,entityName, entityArray) => {
  const params = new URLSearchParams();
  params.append('entityID', entityUpdateID);
  params.append('entityName', entityName);
  params.append('entityArray', entityArray);

  axios.post(apiServerHost + "/manage/topic/builder/create/entity", params)
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

const getEntityList = (callBackFunc, topicId, entityType) => {
  const params = new URLSearchParams();
  params.append('topicID', topicId);
  params.append('entityType', entityType);

  axios.get(apiServerHost + "/manage/topic/builder/get/entityList", {
    params : params,
  })
  .catch( error => {
    
  })
  .then( response => {
    callBackFunc(response);
  })
}

export {createEntity};
export {getEntityList};